import React from "react";
import { Facebook, Instagram, Mail, Phone, MapPin, ArrowUp, Sparkles } from "lucide-react";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      const offerTab = document.getElementById("tab-trigger-oferta");
      if (offerTab) offerTab.click();
    }
  };

  return (
    <footer 
      data-testid="footer-container"
      className="bg-black text-white"
    >
      {/* 8. Call To Action Final */}
      <div className="bg-[#121212] border-t border-b border-white/5 py-20 relative overflow-hidden text-center">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[350px] h-[350px] bg-[#D4AF37]/5 rounded-full filter blur-3xl -z-10" />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          <div className="inline-flex items-center space-x-1 text-[#D4AF37] mb-2">
            <Sparkles size={16} />
            <span className="text-[10px] tracking-[0.3em] uppercase font-semibold">REZERVĂRI 2026 / 2027</span>
          </div>
          
          <h2 
            data-testid="footer-cta-title"
            className="font-serif-lux text-3xl sm:text-5xl text-white font-medium tracking-tight"
          >
            Rezervă acum data evenimentului tău!
          </h2>

          <p 
            data-testid="footer-cta-text"
            className="text-sm sm:text-lg text-white/70 max-w-2xl mx-auto font-light"
          >
            „Contactează-ne astăzi și descoperă cum putem transforma evenimentul tău într-o experiență memorabilă.”
          </p>

          <button
            data-testid="footer-cta-request-offer-btn"
            onClick={scrollToContact}
            className="bg-[#D4AF37] text-black hover:bg-[#C5A880] text-xs font-semibold px-8 py-4 tracking-widest uppercase transition-all duration-300 inline-block"
          >
            Solicită Ofertă
          </button>
        </div>
      </div>

      {/* Footer Details */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          
          {/* Column 1: Brand & Slogan */}
          <div className="space-y-4 md:col-span-1">
            <div className="flex flex-col">
              <span className="font-serif-lux text-2xl tracking-wider text-[#D4AF37] font-semibold">ELYSIUM</span>
              <span className="text-[9px] tracking-[0.4em] text-white/70 uppercase">EVENTS SIBIU</span>
            </div>
            <p className="text-xs text-white/50 leading-relaxed font-light">
              „Locul unde fiecare eveniment devine o amintire de neuitat.” Un concept ultra-premium de sală de evenimente din Sibiu, România.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div className="space-y-4">
            <h4 className="text-xs font-semibold tracking-[0.2em] text-[#D4AF37] uppercase">Linkuri Rapide</h4>
            <ul className="space-y-2 text-xs font-light text-white/60">
              <li><button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="hover:text-[#D4AF37] transition-colors">Acasă</button></li>
              <li><a href="#despre-noi" className="hover:text-[#D4AF37] transition-colors">Despre Noi</a></li>
              <li><a href="#servicii" className="hover:text-[#D4AF37] transition-colors">Servicii Exclusive</a></li>
              <li><a href="#galerie" className="hover:text-[#D4AF37] transition-colors">Galerie Foto</a></li>
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div className="space-y-4">
            <h4 className="text-xs font-semibold tracking-[0.2em] text-[#D4AF37] uppercase">Contact direct</h4>
            <ul className="space-y-2 text-xs font-light text-white/60">
              <li className="flex items-center space-x-2"><MapPin size={12} className="text-[#D4AF37]" /> <span>Sibiu, România</span></li>
              <li className="flex items-center space-x-2"><Phone size={12} className="text-[#D4AF37]" /> <span>0720 820 028</span></li>
              <li className="flex items-center space-x-2"><Mail size={12} className="text-[#D4AF37]" /> <span>contact@elysiumevents.ro</span></li>
            </ul>
          </div>

          {/* Column 4: Social Media */}
          <div className="space-y-4">
            <h4 className="text-xs font-semibold tracking-[0.2em] text-[#D4AF37] uppercase font-bold">Social Media</h4>
            <p className="text-xs text-white/50 font-light">
              Urmărește-ne activitatea pe rețelele noastre de socializare pentru noutăți și evenimente live.
            </p>
            <div className="flex space-x-4 pt-2">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                data-testid="facebook-integration-link"
                className="p-2.5 bg-[#121212] border border-white/5 text-white/70 hover:text-[#D4AF37] hover:border-[#D4AF37] transition-all duration-300"
                title="Facebook Elysium"
              >
                <Facebook size={16} />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                data-testid="instagram-integration-link"
                className="p-2.5 bg-[#121212] border border-white/5 text-white/70 hover:text-[#D4AF37] hover:border-[#D4AF37] transition-all duration-300"
                title="Instagram Elysium"
              >
                <Instagram size={16} />
              </a>
            </div>
          </div>

        </div>

        {/* Copyright and back to top */}
        <div className="flex flex-col sm:flex-row items-center justify-between border-t border-white/10 mt-16 pt-8 text-[11px] text-white/40 font-light">
          <p>© 2026 Elysium Events. Toate drepturile rezervate. Design de înaltă clasă.</p>
          <button 
            data-testid="scroll-to-top-btn"
            onClick={scrollToTop}
            className="flex items-center space-x-1 hover:text-[#D4AF37] transition-colors mt-4 sm:mt-0 uppercase tracking-widest text-[9px] font-semibold"
          >
            <span>Înapoi sus</span>
            <ArrowUp size={12} />
          </button>
        </div>
      </div>
    </footer>
  );
}
